import type { DomainHooksRegistryInterface } from "~/context/domain-hooks-context/domain-hooks-registry.interface";


import { useColorExplorer } from "~/modules/main/hooks/use-color-explorer/use-color-explorer";


/**
 * Domain hook implementations
 * 
 * This is a collection of all the domain hooks that are available in the application.
 * It is used to provide the domain hooks to the application.
 * 
 * You can access them by using the `useDomainHooks` hook.
 */
export const domainHooksRegistry: DomainHooksRegistryInterface = {

    useColorExplorer: useColorExplorer,

} as DomainHooksRegistryInterface;